export default __webpack_public_path__ + "static/media/hht2_ep_15.5d14d837.png";